import BadgeConstants from "./BadgeConstants";

const BadgeUtilities = {
  getBadgesByBadgeNr(badgesData) {
    let returnBadges = [];

    let sortedData = BadgeUtilities.getSortedBadges(badgesData);

    for (var i = 0; i < sortedData.length; i++) {
      let badge = sortedData[i];
      let badgeNr = badge.badgeNr;
      const index = BadgeConstants.badges.map((e) => e.badgeNr).indexOf(badgeNr);
      let badgeToPush = BadgeConstants.badges[index];
      returnBadges.push(badgeToPush);
    }

    return returnBadges;
  },

  /* Sort badges using badgeNr to represent order in array */
  getSortedBadges(badgesData) {
    return badgesData.sort(function (a, b) {
      return BadgeConstants.badges.map((e) => e.badgeNr).indexOf(a.badgeNr) - BadgeConstants.badges.map((e) => e.badgeNr).indexOf(b.badgeNr);
    });
  },
};

export default BadgeUtilities;
